import * as React from 'react';
import { Button } from '@blueprintjs/core';
import { t } from '@patterns/locale';
import { capitalize } from '@patterns/core';
export function ConfirmButton(_a) {
    var confirmTitle = _a.confirmTitle, onConfirm = _a.onConfirm, title = _a.title, _b = _a.minimal, minimal = _b === void 0 ? false : _b, _c = _a.outlined, outlined = _c === void 0 ? false : _c, icon = _a.icon, style = _a.style;
    var _d = React.useState(false), isPressed = _d[0], setIsPressed = _d[1];
    React.useEffect(function () {
        var handle;
        if (isPressed) {
            handle = window.setTimeout(function () {
                setIsPressed(false);
                handle = 0;
            }, 10000);
        }
        return function () {
            if (handle !== 0) {
                window.clearTimeout(handle);
            }
        };
    }, [isPressed]);
    return (React.createElement(Button, { style: style, minimal: minimal, outlined: outlined, text: isPressed ? (title || (confirmTitle || capitalize(t('confirm')))) : title, icon: isPressed ? "tick" : (icon ? icon : "trash"), intent: isPressed ? "danger" : "warning", onClick: function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            if (isPressed) {
                onConfirm();
            }
            else {
                setIsPressed(true);
            }
        } }));
}
//# sourceMappingURL=confirm_button.js.map